import { Modal, useModal } from '@gyym/ui'
import React from 'react'

import { FormValues, SearchForm } from '@/components/Forms/SearchForm'

export const useSearchConditionsModal = () => {
  const { openModal } = useModal()

  return React.useCallback(
    ({
      title = '条件を指定して探す',
      values,
      onSubmit,
      onClose,
    }: {
      title?: string
      values?: Partial<FormValues>
      onSubmit: (values: FormValues) => void
      onClose?: () => void
    }) => {
      openModal(Modal, {
        title,
        baseWidth: 500,
        expandOnSmallDevices: true,
        onClose,
        children: ({ onClose }) => (
          <SearchForm
            values={values}
            onSubmit={(values) => {
              onSubmit(values)
              onClose?.()
            }}
          >
            {({ fields, submit }) => (
              <>
                <Modal.Body>{fields}</Modal.Body>
                <Modal.Footer>{submit}</Modal.Footer>
              </>
            )}
          </SearchForm>
        ),
      })
    },
    [openModal],
  )
}
